<template>
  <div>


    <b-row>
      <b-col md="9">
        <h4 class="font-weight-bold ml-1">Planlegger</h4>
      </b-col>

      <!-- <b-col md="1">
        <div class="float-right">
          <label class="nav-item navbar-text navbar-search-box p-0 active">
            <i class="ion ion-ios-search navbar-icon align-middle"></i>
            <span class="navbar-search-input pl-2">
              <b-form-input
                class="ml-2"
                v-model="filter"
                placeholder="Søk"
              ></b-form-input>
            </span>
          </label>
        </div>
      </b-col> -->

      <b-col md="2">
        <!-- <b-button
          class="float-right"
          variant="primary"
          v-b-modal.newOrder
          @click="openModal()"
        >Opprett ny ordre</b-button>-->
      </b-col>
    </b-row>

    <b-row class="mt-1">

      

      <b-col
        cols="2"
        class="calendar-width"
      >
        <div>
          <v-calendar
            is-expanded
            show-iso-weeknumbers
            :attributes="calendar"
            :rows="$screens({ default: 1, xs: 1, sm:1, md: 2, lg: 2, xl: 3 })"
          />
        </div>

      </b-col>





      <b-col>

        <h6 v-if="this.orders[0] == null && this.isLoading == false">Ingen ordrer tilgjengelig </h6>

        <div class="height-max">

          <ul class="timeline">
            <li
              v-for="order in filterBy(orders)"
              :key="order.id"
            >
              <b-card class="mr-3">
                <b-badge pill v-if="order.status == 'Bestilling'" variant="secondary">{{ order.status }} </b-badge>
                <b-badge pill v-if="order.status == 'Ordre'" variant="primary">{{ order.status }}</b-badge>
                <b-badge pill v-if="order.status == 'I arbeid'" variant="dark">{{ order.status }}  </b-badge>
                <b-badge pill v-if="order.status == 'Arbeid avsluttet'" variant="warning">{{ order.status }}</b-badge>
                <b-badge pill v-if="order.status == 'Til fakturering'" variant="info">{{ order.status }}</b-badge>
                <b-badge pill v-if="order.status == 'Fakturert'" variant="success">{{ order.status }}</b-badge>
                <b-badge pill v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>

                <h4 class="font-weight-bold mt-2">
                  {{ order.ordernumber }} - {{ order.customer_company.name }}
                  <span v-if="order.site.name != null">({{ order.site.name }})</span>
                </h4>
                <h5> {{ order.type }} </h5>
                <h5>Startdato: {{ $date(order.startdate).format("DD.MM.YYYY") }} ({{ order.startdate | dayjs("from") }}) </h5>
                <h5>Sluttdato: {{ $date(order.enddate).format("DD.MM.YYYY") }} ({{ order.enddate | dayjs("from") }}) </h5>
                <h5 v-if="order.vessel != null">Fartøy: {{ order.vessel.name }} </h5>
                <h5 v-if="order.captain != null">Kaptein: {{ order.captain.name }} </h5>
                <b-button
                  class="mr-1"
                  variant="outline-primary"
                  @click="editOrder(order)"
                >Rediger</b-button>
              </b-card>
            </li>
          </ul>
        </div>

      </b-col>

      <!-- Edit card -->

      <b-col>

        <b-card
          v-if="editOrderCard == false"
          bg-variant="light"
          class="height-max"
        >
          <h6>Ordre</h6>
          <p>Ingen ordre valgt</p>
        </b-card>

        <b-card
          bg-variant="light"
          v-if="editOrderCard"
          class="height-max"
        >

          <div>

            <b-badge
              pill
              v-if="order.status == 'Bestilling'"
              variant="info"
            >
              {{ order.status }}
            </b-badge>

            <b-badge
              pill
              v-if="order.status == 'Ordre'"
              variant="warning"
            >
              {{ order.status }}
            </b-badge>
            <b-badge
              pill
              v-if="order.status == 'I arbeid'"
              variant="primary"
            >
              {{ order.status }}
            </b-badge>

            <b-badge
              pill
              v-if="order.status == 'Arbeid avsluttet'"
              variant="secondary"
            >{{ order.status }}</b-badge>

            <b-badge
              pill
              v-if="order.status == 'Utført'"
              variant="success"
            >
              {{ order.status }}
            </b-badge>

            <b-badge
              pill
              v-if="order.status == 'Kansellert'"
              variant="danger"
            >{{ order.status }}</b-badge>

            <b-button
              variant="primary"
              class="float-right"
              @click="updateOrder(order)"
            >
              Lagre
            </b-button>

            <b-button
              class="float-right mr-2"
              variant="default"
              @click="closeOrder()"
            >Avbryt</b-button>

            <h4 class="font-weight-bold mt-2">
              {{ order.ordernumber }} - {{ order.customer_company.name }}
              <span v-if="order.site.name != null">({{ order.site.name }})</span>
            </h4>

            <b-form-group label="Selskap">
              <vue-typeahead-bootstrap
                class="mb-2"
                v-model="queryCustomer"
                :ieCloseFix="false"
                :data="customers"
                :serializer="(item) => item.name"
                @hit="order.customer_company = $event"
                placeholder="Søk selskap"
                @input="lookupCustomer"
              />
            </b-form-group>

            <b-form-group label="Type">
              <b-form-select
                class="mr-3 mb-1"
                v-model="order.type"
                :options="orderType"
                placeholder="Type"
              ></b-form-select>
            </b-form-group>

            <b-form-group label="Lokasjon">
              <vue-typeahead-bootstrap
                class="mr-3 mb-1"
                v-model="querySites"
                :ieCloseFix="false"
                :data="sites"
                :serializer="(item) => item.number + ' - ' + item.name"
                @hit="order.site = $event"
                placeholder="Søk lokaliteter"
                @input="lookupSites"
              />
            </b-form-group>

            <b-form-group label="Startdato">
              <datepicker
                class="mr-3 mb-1"
                v-model="order.startdate"
                :format="customFormatter"
                :bootstrap-styling="true"
              >
              </datepicker>
            </b-form-group>

            <b-form-group label="Sluttdato">
              <datepicker
                class="mr-3 mb-1"
                v-model="order.enddate"
                :format="customFormatter"
                :bootstrap-styling="true"
              >
              </datepicker>
            </b-form-group>

            <b-form-group label="Fartøy">
              <b-form-select
                class="mr-3 mb-1"
                v-model="order.vessel"
                :options="vesselSelect"
              ></b-form-select>
            </b-form-group>

            <b-form-group label="Kaptein">
              <b-form-select
                class="mr-3 mb-1"
                v-model="order.captain"
                :options="captainSelect"
              ></b-form-select>
            </b-form-group>

            <b-form-group label="Status">
              <b-form-select
                class="mr-3 mb-1"
                v-model="order.status"
                :options="statusOptions"
                placeholder="status"
              ></b-form-select>
            </b-form-group>

            <b-form-group>
              <b-form-checkbox
                class="mr-3 mt-1"
                v-model="order.send_confirmation"
              >
                Send ordrebekreftelse
              </b-form-checkbox>
            </b-form-group>

          </div>

          <!-- <template #footer>
            <em>Footer Slot</em>
          </template> -->

        </b-card>

      </b-col>

    </b-row>

  </div>
</template>

<script>
import axios from "axios";

import Datepicker from "vuejs-datepicker";
import Vue2Filters from "vue2-filters";

import VueMoment from "vue-moment";
import moment from "moment";
import { debounce } from "lodash";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import VueTagsInput from "@johmun/vue-tags-input";



export default {
  components: {
    
    Datepicker,
    
    VueMoment,
    moment,
    VueTypeaheadBootstrap,
    VueTagsInput,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      user: {},
      order: {},
      orders: [],
      sites: [],
      crew: [],
      tag: {},
      tags: [],
      isLoading: false,
      fullPage: true,
      editOrderCard: false,
      showNewCustomer: false,
      queryCustomer: "",
      querySites: "",
      value: [],
      fields: [
        { key: "status", label: "Status", sortable: true },
        {
          key: "ordertitle",
          label: "Ordre",
          sortable: true,
          class: "text-left",
        },

        { key: "type", label: "Type", sortable: true },
        { key: "vessel.name", label: "Fartøy", sortable: true },
        { key: "createdAt", label: "Bestilt", sortable: true },
        { key: "startdate", label: "Start", sortable: true },
        { key: "completed", label: "Fullført", sortable: true },
        { key: "actions", label: "Rediger", sortable: true },
      ],
      orderType: [
        { value: "Avlusning", text: "Avlusning" },
        { value: "Notspyling", text: "Notspyling" },
        { value: "Servicearbeid", text: "Servicearbeid" },
        { value: "Brønnbåt", text: "Brønnbåt" },
      ],
      statusOptions: [
        { value: "Bestilling", text: "Bestilling" },
        { value: "Ordre", text: "Ordre" },
        { value: "I arbeid", text: "I arbeid" },
        { value: "Arbeid avsluttet", text: "Arbeid avsluttet" },
        { value: "Utført", text: "Utført" },
        { value: "Kansellert", text: "Kansellert" },
      ],
      calendar: [],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumOrdersTotal() {
      return this.orders.length;
    },
  },
  watch: {
    // whenever question changes, this function will run
    vessel: function () {
      this.order.vessel = this.vessel;
    },
    captain: function () {
      this.order.captain = this.captain;
    },
  },
  methods: {
    getUser() {
      axios.get("https://api.eines-as.no/users/me").then((res) => {
        this.user = res.data;
        this.company = res.data.company;
        this.order.ordernumber = res.data.company.ordernumber;
        this.order.supplier_company = res.data.company.id;
      });
    },
    getOrders() {
      this.isLoading = true;
      var company = localStorage.getItem("company");
      axios
        .get(
          "https://api.eines-as.no/orders?_sort=startdate:ASC&status=Bestilling&status=Ordre&status=I arbeid&_where[supplier_company]=" +
            company
        )
        .then((res) => {
          this.orders = res.data;
          this.isLoading = false;

          // Orders to calendar attributes
          var orderArray = [];

          this.orders.forEach((order) => {
            if (order.status == "Bestilling") {
              var dotcolor = "blue";
            }
            if (order.status == "Ordre") {
              var dotcolor = "yellow";
            }
            if (order.status == "I arbeid") {
              var dotcolor = "indigo";
            }

            if (order.status == "Arbeid avsluttet") {
              var dotcolor = "gray";
            }

            if (order.status == "Utført") {
              var dotcolor = "green";
            }
            if (order.status == "Kansellert") {
              var dotcolor = "red";
            }

            var calendarObject = {
              highlight: {
                start: { fillMode: "outline", color: dotcolor },
                base: { fillMode: "light", color: dotcolor },
                end: { fillMode: "solid", color: dotcolor },
              },
              dot: dotcolor,
              dates: { start: order.startdate, end: order.enddate },
               popover: {
                  label: order.ordernumber +
                    " - " +
                    order.customer_company.name +
                    " (" +
                    order.site.name +
                    ") - " +
                    order.type +
                    " - " + order.status,
                  visibility: "focus",
                },
            };

            orderArray.push(calendarObject);
          });

          this.calendar = orderArray;
        });
    },
    getCustomers() {
      axios
        .get("https://api.eines-as.no/companies?_where[type]=Customer")
        .then((res) => {
          this.customers = res.data;
        });
    },
    getVessels() {
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/vessels?_where[company]=" + company)
        .then((response) => {
          var vesselSelect = [];
          var vesselDataArray = response.data;

          vesselDataArray.forEach((data) => {
            var vesselObject = {
              value: data,
              text: data.name,
            };
            vesselSelect.push(vesselObject);
          });

          this.vesselSelect = vesselSelect;
        });
    },
    getCaptain() {
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/crews?_where[company]=" + company)
        .then((response) => {
          this.crew = response.data;
          var captainSelect = [];
          var captainData = response.data;

          captainData.forEach((data) => {
            var captainObject = {
              value: data,
              text: data.name,
            };
            captainSelect.push(captainObject);
          });
          this.captainSelect = captainSelect;
        });
    },

    createCustomer() {
      axios
        .post("https://api.eines-as.no/companies/", this.newcompany)
        .then((response) => {
          this.order.customer_company = response.data;
          this.showNewCustomer = true;
          this.$bvModal.hide("newCustomer");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveOrder() {
      axios
        .post("https://api.eines-as.no/orders", this.order)
        .then((response) => {
          this.$bvModal.hide("newOrder");
          this.$router.push("/dashboard/order-edit/" + response.data.id);

          if (this.newconfirmation == true) {
            this.sendConfirmation(response.data);
          }

          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    updateOrder(order) {
      this.isLoading = true;
      this.editOrderCard = false;

      // Send order confirmation

      if (this.order.send_confirmation == true) {
        this.order.send_confirmation = false;

        var message = {
          to: this.order.contact_email1,
          cc: this.order.contact_email2,
          subject:
            "Ordrebekreftelse - " +
            this.order.supplier_company.name +
            " - " +
            this.order.ordernumber,
          text:
            "Dette er en ordrebekreftelse fra " +
            this.order.supplier_company.name +
            " med ordrenummer: " +
            this.order.ordernumber,
        };

        axios
          .post("https://api.eines-as.no/messages", message)
          .then((response) => {})
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      }

      axios
        .put("https://api.eines-as.no/orders/" + order.id, order)
        .then((response) => {
          this.order = {};
          this.querySites = "";
          this.queryCustomer = "";
          this.getOrders();
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    getNewCustomer() {
      axios
        .get(
          "https://data.brreg.no/enhetsregisteret/api/enheter/" +
            this.newcompany.orgnumber
        )
        .then((response) => {
          var companyInfo = {
            name: response.data.navn,
            orgnumber: response.data.organisasjonsnummer,
            address: response.data.forretningsadresse.adresse[0],
            postcode: response.data.forretningsadresse.postnummer,
            city: response.data.forretningsadresse.poststed,
            country: response.data.forretningsadresse.land,
            details: {
              registered: response.data.registreringsdatoEnhetsregisteret,
              employees: response.data.antallAnsatte,
              sector: response.data.naeringskode1.beskrivelse,
            },
            type: "Customer",
          };

          this.newcompany = companyInfo;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    sendConfirmation() {},
    lookupSites: debounce(function () {
      // in practice this action should be debounced

      axios
        .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
        .then((response) => {
          this.sites = response.data;
        });
    }, 25),

    editOrder(order) {
      this.order = order;
      this.editOrderCard = true;
    },
    closeOrder() {
      this.editOrderCard = false;
      this.order = {};
    },
    openModal() {
      this.getCustomers();
    },
    closeModal() {
      this.$bvModal.hide("editOrder");
      this.order = {};
    },
    closeCustomerModal() {
      this.$bvModal.hide("newCustomer");
    },
    customFormatter(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    getDates() {
      this.disabledDates = {
        to: new Date(),
      };
    },
  },
  created: function () {
    this.getUser();
    this.getOrders();
    this.getCustomers();
    this.getVessels();
    this.getCaptain();
    this.getDates();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.background-white {
  background: #ffffff;
}

.height-max {
  /* %-height of the viewport */
  max-height: 82.5vh;
  min-height: 82.5vh;
  overflow-x: hidden !important;
}

.calendar-width {
  min-width: 275px;
  max-width: 275px;
}

/* Timeline */

ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #022d56;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>